/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    FETCH_REVIEW_START,
    FETCH_REVIEW_SUCCESS,
    FETCH_REVIEW_FAILURE,
} from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const fetchReview = makeAsyncReducer(
    {
        startType: FETCH_REVIEW_START,
        successType: FETCH_REVIEW_SUCCESS,
        failureType: FETCH_REVIEW_FAILURE,
    },
    { initialData: {} }
);

export const fetchReviewSelector = (state) => state.ratingReviews.fetchReview;
